import { generateResourceReducer } from '../generators/resource.reducer';
import * as types from './project-time.types';
import * as constants from './project-time.constants';

export const projectTimeReducer = generateResourceReducer<types.IProjectTasksTime>({
  STORE: constants.STORE_PROJECT_TIME,
  CLEAR: constants.CLEAR_PROJECT_TIME,
});
